import api from '@api';

const fetchMovements = () => api.get('/traders/me/movements');

const fetchAccountStatementDates = () => api.get('/traders/me/accountStatementDates');

export { fetchMovements, fetchAccountStatementDates };
